'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Column-module_column__ihEsE{display:grid;grid-template-columns:repeat(12,[col-start] 1fr);grid-column-gap:.5rem;-moz-column-gap:.5rem;column-gap:.5rem;grid-auto-rows:min-content}";
var styles = {"column":"Column-module_column__ihEsE"};
styleInject["default"](css_248z, '6747c5ed-f3b3-4db9-9a8e-5b7031ada907');

exports["default"] = styles;
